export interface BookingDraft {
  serviceId: string;
  serviceName: string;
  bookingDate: string;
  bookingTime: string;
  customerName: string;
  phone: string;
  email: string;
  notes: string;
}

export const TIME_SLOTS = [
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
];